import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const procesoMatriculacionSlice = createSlice({
    name: 'proceso_matriculacion',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialState: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                process: "",
                error: "",
            }
        },
        setAllProcess: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setProcess: (state, action) => {
            return {
                items: [],
                item: {},
                process: true,
                message: "",
                error: "",
            }
        },
        setMessage: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getAllProcesByStudentThunk = (ci_estudiante) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/procesos_matriculacion/proceso_estudiante/${ci_estudiante}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setAllProcess(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getAllProcesMatriculationThunk = (ci_estudiante) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/procesos_matriculacion/${ci_estudiante}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setAllProcess(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const firmatContratoThunk = (contract_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/firmar_contrato/${contract_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const subirDocumentosThunk = (ciEstudiante, ciPadre, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/carga_documentos/student/${ciEstudiante}/parent/${ciPadre}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const respondFormThunk = (formId, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/respondForm/${formId}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const finishProccesThunk = (ciStudent, ciParent, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/finishProcess/${ciStudent}/${ciParent}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const chageStatePrivacePolicyThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/cambiar_estado_aceptacion_politica`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const chageStatePlaceThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/cambiar_estado_reserva_cupo`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const clearContracThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/clear_contract`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const clearDocumentsThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/clear_document`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const clearFormThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/procesos_matriculacion/clear_form`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const sendReminderContractThunk = (data) => dispatch => {
    dispatch(setProcess());
    axios.put(`/procesos_matriculacion/send_reminder_contract`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
};

export const { initialState,
    setAllProcess,
    setProcess,
    setMessage,
    setError,
} = procesoMatriculacionSlice.actions;

export default procesoMatriculacionSlice.reducer;